<template>
  <div>
    <div>
      <div class="d-flex justify-content-between align-items-center">
        <b-button-group size="sm" style="width: 300px">
          <b-button
            v-for="tab in tabs"
            :variant="activeTab === tab.value ? 'primary' : ''"
            @click="activeTab = tab.value"
            style="width: 100%; height: 30px"
            :key="tab.value"
            class="mr-1"
          >
            <div v-if="tab.show">
              {{ tab.text }}
            </div>
          </b-button>
        </b-button-group>

        <b-button v-if="currentKeys.length > 1" @click="toggleAllCollapse" class="icon-button">
          <Maximize2 v-if="!areAllOpen" :size="20" />
          <Minimize2 v-else :size="20" />
        </b-button>
      </div>
      <div v-if="activeTab === 'optionals'">
        <div class="mt-4">
          <template v-if="areOptionalsExistent">
            <div>
              <div
                v-for="(optionals, kuerzel) in aggregatedOptionalsNachKuerzel"
                :key="kuerzel"
                class="expandable-row"
                :class="{ 'expandable-row-expanded': isOpen[kuerzel] }"
              >
                <div
                  class="section-header d-flex align-items-center"
                  @click="toggleCollapse(kuerzel)"
                  style="cursor: pointer; height: 40px"
                >
                  <span style="font-weight: 600; font-size: 16px" class="d-flex align-items-center ml-4">
                    <ChevronUp v-if="isOpen[kuerzel]" :size="20" />
                    <ChevronDown v-else :size="20" />
                    <span class="ml-2">
                      {{
                        optionals[0]?.langname
                          ? `${
                              optionals[0].langname.charAt(0).toUpperCase() + optionals[0].langname.slice(1)
                            } (${kuerzel})`
                          : kuerzel
                      }}
                    </span>
                  </span>
                </div>

                <b-collapse :visible="isOpen[kuerzel]">
                  <div class="flight-table-container">
                    <b-table
                      :items="optionals"
                      :fields="optionalsTableFields"
                      class="blank-flight-table"
                      responsive
                    >
                      <template #cell(bnr)="data">
                        {{ data.item.bnr || '' }}
                      </template>

                      <template #cell(teilnehmernamen)="data">
                        {{ nameFormatter(data.item.teilnehmerName) }}
                      </template>
                    </b-table>
                  </div>
                </b-collapse>
              </div>
            </div>
          </template>
          <template v-else><div class="text-center p-3">Keine Optionals vorhanden.</div></template>
        </div>
      </div>

      <div v-if="activeTab === 'extensions'">
        <div class="mt-4">
          <template
            v-if="
              areVerleangerungenExistent ||
              areVerleangerungenInEigenregieExistent ||
              areVerleangerungenOTAExistent ||
              areVerleangerungenCountryManagerExistent
            "
          >
            <div>
              <div
                v-for="(verlaengerungen, kuerzel) in aggregatedVerlaengerungenNachKuerzel"
                :key="kuerzel"
                class="expandable-row"
                :class="{ 'expandable-row-expanded': isOpen[kuerzel] }"
              >
                <div
                  class="section-header d-flex align-items-center"
                  @click="toggleCollapse(kuerzel)"
                  style="cursor: pointer; height: 40px"
                >
                  <span style="font-weight: 600; font-size: 16px" class="d-flex align-items-center ml-4">
                    <ChevronUp v-if="isOpen[kuerzel]" :size="20" />
                    <ChevronDown v-else :size="20" />
                    <span class="ml-2">
                      {{
                        verlaengerungen[0]?.langname
                          ? `${
                              verlaengerungen[0].langname.charAt(0).toUpperCase() +
                              verlaengerungen[0].langname.slice(1)
                            } (${kuerzel})`
                          : kuerzel
                      }}
                    </span>
                  </span>
                </div>

                <b-collapse :visible="isOpen[kuerzel]">
                  <div class="flight-table-container">
                    <b-table
                      :items="verlaengerungen"
                      :fields="verlaengerungenTableFields"
                      class="blank-flight-table"
                      responsive
                    >
                      <template #cell(reisezeitraum)="data">
                        {{ formatZeitraum(data.item.startdatum, data.item.dauer) }}
                      </template>

                      <template #cell(bnr)="data">
                        {{ data.item.bnr || '' }}
                      </template>

                      <template #cell(pax)="data">
                        {{ data.item.pax }}
                      </template>

                      <template #cell(zimmertyp)="data">
                        {{ data.item.zimmertyp }}
                      </template>

                      <template #cell(verpflegung)="data">
                        {{
                          data.item.verpflegung
                            ? data.item.verpflegung === 'Verpflegung'
                              ? 'Verpflegung laut Programm'
                              : data.item.verpflegung
                            : '-'
                        }}
                      </template>

                      <template #cell(teilnehmernamen)="data">
                        {{ nameFormatter(data.item.teilnehmerName || '-') }}
                      </template>

                      <template #cell(kundenwuensche)="data">
                        {{ formatKundenwuensche(data.item.kundenwuensche) }}
                      </template>
                    </b-table>
                  </div>
                </b-collapse>
              </div>

              <!-- Verlängerungen in Eigenregie -->
              <template v-if="areVerleangerungenInEigenregieExistent">
                <div class="expandable-row" :class="{ 'expandable-row-expanded': isOpen.eigenregie }">
                  <div
                    class="section-header d-flex align-items-center"
                    @click="toggleCollapse('eigenregie')"
                    style="cursor: pointer; height: 40px"
                  >
                    <span style="font-weight: 600; font-size: 16px" class="d-flex align-items-center ml-4">
                      <ChevronUp v-if="isOpen.eigenregie" :size="20" />
                      <ChevronDown v-else :size="20" />
                      <span class="ml-2">Verlängerung in Eigenregie</span>
                    </span>
                  </div>

                  <b-collapse :visible="isOpen.eigenregie">
                    <div class="flight-table-container">
                      <b-table
                        :items="verleangerungenInEigenregieTabellenFormat"
                        :fields="verlaengerungenInEigenregieTableFields"
                        class="blank-flight-table"
                        responsive
                      >
                        <template #cell(reisezeitraum)="data">
                          {{ data.item.reisezeitraum }}
                        </template>

                        <template #cell(bnr)="data">
                          {{ data.item.bnr }}
                        </template>

                        <template #cell(pax)="data">
                          {{ data.item.pax }}
                        </template>

                        <template #cell(teilnehmernamen)="data">
                          {{ nameFormatter(data.item.teilnehmerName) }}
                        </template>
                      </b-table>
                    </div>
                  </b-collapse>
                </div>
              </template>

              <template v-if="areVerleangerungenOTAExistent">
                <div class="expandable-row" :class="{ 'expandable-row-expanded': isOpen.ota }">
                  <div
                    class="section-header d-flex align-items-center"
                    @click="toggleCollapse('ota')"
                    style="cursor: pointer; height: 40px"
                  >
                    <span style="font-weight: 600; font-size: 16px" class="d-flex align-items-center ml-4">
                      <ChevronUp v-if="isOpen.ota" :size="20" />
                      <ChevronDown v-else :size="20" />
                      <span class="ml-2">
                        Gebucht über OTA -
                        {{ verleangerungenOTATabellenFormat[0]?.unterkunft || '' }}
                      </span>
                    </span>
                  </div>

                  <b-collapse :visible="isOpen.ota">
                    <div class="flight-table-container">
                      <b-table
                        :items="
                          formatVerleangerungOtaOderCountryManager(
                            groupedVerleangerungenOtaOderCountryManager(allVerlaengerungenOTA)
                          )
                        "
                        :fields="verlaengerungenOtaOderCountryManagerFields"
                        class="blank-flight-table"
                        responsive
                      >
                        <template #cell(reisezeitraum)="data">
                          {{ data.item.reisezeitraum }}
                        </template>

                        <template #cell(bnr)="data">
                          {{ data.item.bnr }}
                        </template>

                        <template #cell(pax)="data">
                          {{ data.item.pax }}
                        </template>

                        <template #cell(zimmerartVerpflegung)="data">
                          {{ data.item.zimmerartVerpflegung }}
                        </template>

                        <template #cell(teilnehmernamen)="data">
                          {{ nameFormatter(data.item.teilnehmerName) }}
                        </template>
                      </b-table>
                    </div>
                  </b-collapse>
                </div>
              </template>

              <template v-if="areVerleangerungenCountryManagerExistent">
                <div class="expandable-row" :class="{ 'expandable-row-expanded': isOpen.countryManager }">
                  <div
                    class="section-header d-flex align-items-center"
                    @click="toggleCollapse('countryManager')"
                    style="cursor: pointer; height: 40px"
                  >
                    <span style="font-weight: 600; font-size: 16px" class="d-flex align-items-center ml-4">
                      <ChevronUp v-if="isOpen.countryManager" :size="20" />
                      <ChevronDown v-else :size="20" />
                      <span class="ml-2">
                        Gebucht über Country Manager
                        {{ verleangerungenCountryManagerTabellenFormat[0]?.kreditor || '' }} -
                        {{ verleangerungenCountryManagerTabellenFormat[0]?.unterkunft || '' }}
                      </span>
                    </span>
                  </div>

                  <b-collapse :visible="isOpen.countryManager">
                    <div class="flight-table-container">
                      <b-table
                        :items="
                          formatVerleangerungOtaOderCountryManager(
                            groupedVerleangerungenOtaOderCountryManager(allVerlaengerungenCountryManager)
                          )
                        "
                        :fields="verlaengerungenOtaOderCountryManagerFields"
                        class="blank-flight-table"
                        responsive
                      >
                        <template #cell(reisezeitraum)="data">
                          {{ data.item.reisezeitraum }}
                        </template>

                        <template #cell(bnr)="data">
                          {{ data.item.bnr }}
                        </template>

                        <template #cell(pax)="data">
                          {{ data.item.pax }}
                        </template>

                        <template #cell(zimmerartVerpflegung)="data">
                          {{ data.item.zimmerartVerpflegung }}
                        </template>

                        <template #cell(teilnehmernamen)="data">
                          {{ nameFormatter(data.item.teilnehmerName) }}
                        </template>
                      </b-table>
                    </div>
                  </b-collapse>
                </div>
              </template>
            </div>
          </template>

          <template v-else>
            <div class="text-center p-3">Keine Verlängerungen vorhanden.</div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Maximize2, Minimize2, ChevronUp, ChevronDown } from 'lucide-vue';
import { formatDateWithoutHours, formatName } from '@/core/common/helpers/utils';
export default {
  components: {
    Maximize2,
    Minimize2,
    ChevronUp,
    ChevronDown,
  },
  props: { vorgaenge: { type: Array } },
  data() {
    return { activeTab: 'optionals', isOpen: {}, formatDateWithoutHours };
  },
  // damit alle Optionals, Verlängerungen und Verlängerungen in Eigenregire per default ausgeklappt sind
  created() {
    const optionals = Object.keys(this.aggregatedOptionalsNachKuerzel);
    const verlaengerungen = Object.keys(this.aggregatedVerlaengerungenNachKuerzel);

    optionals.forEach(kuerzel => {
      this.$set(this.isOpen, kuerzel, true);
    });

    verlaengerungen.forEach(kuerzel => {
      this.$set(this.isOpen, kuerzel, true);
    });

    if (this.areVerleangerungenInEigenregieExistent) {
      this.$set(this.isOpen, 'eigenregie', true);
    }

    if (this.areVerleangerungenOTAExistent) {
      this.$set(this.isOpen, 'ota', true);
    }

    if (this.areVerleangerungenCountryManagerExistent) {
      this.$set(this.isOpen, 'countryManager', true);
    }
  },
  computed: {
    tabs() {
      return [
        {
          show: true,
          value: 'optionals',
          text: `Optionals (${
            [
              ...Object.values(this.aggregatedOptionalsNachKuerzel)
                .flat()
                .map(teilnehmer => teilnehmer.teilnehmerName),
            ].length
          })`,
        },
        {
          show: true,
          value: 'extensions',
          text: `Verlängerungen (${this.gesamteTeilnehmendeAnzahlInVerlaengerungen})`,
        },
      ];
    },
    // Filtere nur aktive Buchungen
    vorgaengeWithActiveBuchung() {
      return this.vorgaenge.filter(vorgang => vorgang.blankState === 'Buchung');
    },
    // Alle Teilnehmer aus aktiven Buchungen
    allTeilnehmerFromActiveBuchungen() {
      return this.vorgaengeWithActiveBuchung.flatMap(vorgang =>
        vorgang.teilnehmers
          .filter(teilnehmer => teilnehmer.deletedAt === null)
          .map(teilnehmer => ({
            ...teilnehmer,
            bnr: vorgang.id,
            teilnehmerName: teilnehmer.name,
            kundenwuensche: teilnehmer.kundenwuensche,
          }))
      );
    },

    // Alle Verlängerungen sammeln
    allVerlaengerungen() {
      return this.allTeilnehmerFromActiveBuchungen.flatMap(teilnehmer =>
        teilnehmer.verlaengerungen
          .filter(verl => verl.deletedAt === null)
          .map(verlaengerung => ({
            ...verlaengerung,
            bnr: teilnehmer.bnr,
            teilnehmerName: teilnehmer.teilnehmerName,
            kundenwuensche: teilnehmer.kundenwuensche,
          }))
      );
    },

    aggregatedVerlaengerungen() {
      return this.allVerlaengerungen.reduce((acc, curr) => {
        // überprüfen nach folgenden keys, ob die Objects übereinstimmen
        const matchingObject = acc.find(
          verlaengerung =>
            verlaengerung.kuerzel === curr.kuerzel &&
            verlaengerung.dauer === curr.dauer &&
            verlaengerung.zimmertyp === curr.zimmertyp &&
            verlaengerung.zimmerzahl === curr.zimmerzahl &&
            verlaengerung.bnr === curr.bnr &&
            verlaengerung.startdatum === curr.startdatum
        );

        if (matchingObject != null) {
          matchingObject.teilnehmerNamen = [...matchingObject.teilnehmerNamen, curr.teilnehmerName];
          matchingObject.kundenwuensche = [...matchingObject.kundenwuensche, curr.kundenwuensche];
          matchingObject.verpflegung = [...matchingObject.verpflegung, curr.verpflegung];
        } else {
          const newObject = {
            ...curr,
            teilnehmerNamen: [curr.teilnehmerName],
            kundenwuensche: [curr.kundenwuensche],
            verpflegung: [curr.verpflegung],
          };
          // entfernt den key "teilnehmerName", da wir den namen in dem array "teilnehmerNamen" speichern
          delete newObject.teilnehmerName;
          acc = [...acc, newObject];
        }

        return acc;
      }, []);
    },

    // Verlängerungen nach Kürzel aggregieren
    aggregatedVerlaengerungenNachKuerzel() {
      return this.aggregatedVerlaengerungen.reduce((acc, curr) => {
        const { teilnehmerNamen, kundenwuensche, verpflegung } = curr;
        const countTeilnehmer = teilnehmerNamen?.length;

        const neueZeilen = [];

        for (let i = 0; i < countTeilnehmer; i++) {
          if (i === 0) {
            const newObj = {
              ...curr,
              teilnehmerName: teilnehmerNamen?.[i],
              pax: countTeilnehmer,
              zimmertyp: curr.zimmerzahl ? `${curr.zimmerzahl}x ${curr.zimmertyp}` : curr.zimmertyp || '',
              kundenwuensche: kundenwuensche[i],
              verpflegung: verpflegung[i],
            };
            delete newObj.teilnehmerNamen;
            neueZeilen.push(newObj);
          } else {
            neueZeilen.push({
              kuerzel: curr.kuerzel,
              dauer: '',
              zimmertyp: '',
              zimmerzahl: '',
              startdatum: '',
              buchungsdatum: '',
              deletedAt: null,
              bnr: '',
              teilnehmerName: teilnehmerNamen?.[i],
              pax: '',
              kundenwuensche: kundenwuensche[i],
              verpflegung: verpflegung[i],
            });
          }
        }

        if (curr.kuerzel in acc) {
          acc[curr.kuerzel] = [...acc[curr.kuerzel], ...neueZeilen];
        } else {
          acc[curr.kuerzel] = neueZeilen;
        }

        return acc;
      }, {});
    },

    // Verlängerungen in Eigenregie
    allVerlaengerungenInEigenregie() {
      return this.vorgaengeWithActiveBuchung.flatMap(vorgang =>
        vorgang.teilnehmers
          .filter(teilnehmer => teilnehmer.deletedAt === null)
          .flatMap(teilnehmer =>
            (teilnehmer.teilnehmerVerlaengerungen || [])
              .filter(
                verlaengerung =>
                  verlaengerung.teilnehmerVerlaengerungTyp === 'Eigenregie' &&
                  verlaengerung.deletedAt === null
              )
              .map(verlaengerung => ({
                bnr: verlaengerung.bnr,
                reisezeitraum: `${verlaengerung.von
                  ?.split('T')[0]
                  .split('-')
                  .reverse()
                  .join('.')} - ${verlaengerung.bis?.split('T')[0].split('-').reverse().join('.')}`,
                pax: vorgang.npx,
                teilnehmerNamen: [teilnehmer.name],
              }))
          )
      );
    },

    // Gruppierte Verlängerungen in Eigenregie
    groupedVerleangerungenInEigenregie() {
      return this.allVerlaengerungenInEigenregie.reduce((acc, curr) => {
        const key = `${curr.bnr}-${curr.reisezeitraum}`;

        if (!acc[key]) {
          acc[key] = {
            bnr: curr.bnr,
            reisezeitraum: curr.reisezeitraum,
            pax: curr.pax,
            teilnehmerNamen: [...curr.teilnehmerNamen],
          };
        } else {
          acc[key].teilnehmerNamen.push(...curr.teilnehmerNamen);
        }
        return acc;
      }, {});
    },

    // Format für Tabelle der Verlängerungen in Eigenregie
    verleangerungenInEigenregieTabellenFormat() {
      return Object.values(this.groupedVerleangerungenInEigenregie).flatMap(gruppe => {
        return gruppe.teilnehmerNamen.map((teilnehmerName, index) => ({
          bnr: index === 0 ? gruppe.bnr : '',
          reisezeitraum: index === 0 ? gruppe.reisezeitraum : '',
          pax: index === 0 ? gruppe.pax : '',
          teilnehmerName,
          zimmer_empty: '',
          verpflegung_empty: '',
          kundenwuensche_empty: '',
        }));
      });
    },

    // Verlängerungen OTA
    allVerlaengerungenOTA() {
      return this.vorgaengeWithActiveBuchung.flatMap(vorgang =>
        vorgang.teilnehmers
          .filter(teilnehmer => teilnehmer.deletedAt === null)
          .flatMap(teilnehmer =>
            (teilnehmer.teilnehmerVerlaengerungen || [])
              .filter(
                verlaengerung =>
                  verlaengerung.teilnehmerVerlaengerungTyp === 'Ota' && verlaengerung.deletedAt === null
              )
              .map(verlaengerung => ({
                bnr: verlaengerung.bnr,
                reisezeitraum: `${verlaengerung.von
                  ?.split('T')[0]
                  .split('-')
                  .reverse()
                  .join('.')} - ${verlaengerung.bis?.split('T')[0].split('-').reverse().join('.')}`,
                pax: vorgang.npx,
                unterkunft: verlaengerung.unterkunft,
                zimmerartVerpflegung: verlaengerung.zimmerartVerpflegung,
                kreditor: verlaengerung.kreditor,
                teilnehmerNamen: [teilnehmer.name],
              }))
          )
      );
    },

    // Verlängerungen CountryManager
    allVerlaengerungenCountryManager() {
      return this.vorgaengeWithActiveBuchung.flatMap(vorgang =>
        vorgang.teilnehmers
          .filter(teilnehmer => teilnehmer.deletedAt === null)
          .flatMap(teilnehmer =>
            (teilnehmer.teilnehmerVerlaengerungen || [])
              .filter(
                verlaengerung =>
                  verlaengerung.teilnehmerVerlaengerungTyp === 'CountryManager' &&
                  verlaengerung.deletedAt === null
              )
              .map(verlaengerung => ({
                bnr: verlaengerung.bnr,
                reisezeitraum: `${verlaengerung.von
                  ?.split('T')[0]
                  .split('-')
                  .reverse()
                  .join('.')} - ${verlaengerung.bis?.split('T')[0].split('-').reverse().join('.')}`,
                pax: vorgang.npx,
                unterkunft: verlaengerung.unterkunft,
                zimmerartVerpflegung: verlaengerung.zimmerartVerpflegung,
                kreditor: verlaengerung.kreditor,
                teilnehmerNamen: [teilnehmer.name],
              }))
          )
      );
    },

    verleangerungenCountryManagerTabellenFormat() {
      return this.formatVerleangerungOtaOderCountryManager(
        this.groupedVerleangerungenOtaOderCountryManager(this.allVerlaengerungenCountryManager)
      );
    },

    verleangerungenOTATabellenFormat() {
      return this.formatVerleangerungOtaOderCountryManager(
        this.groupedVerleangerungenOtaOderCountryManager(this.allVerlaengerungenOTA)
      );
    },

    // Prüfungen
    areVerleangerungenExistent() {
      return this.allVerlaengerungen.length > 0;
    },

    areOptionalsExistent() {
      return this.allOptionalsOhneKontingent.length > 0 || this.allOptionalsMitKontingent.length > 0;
    },

    areVerleangerungenInEigenregieExistent() {
      return this.allVerlaengerungenInEigenregie.length > 0;
    },

    areVerleangerungenOTAExistent() {
      return this.allVerlaengerungenOTA.length > 0;
    },

    areVerleangerungenCountryManagerExistent() {
      return this.allVerlaengerungenCountryManager.length > 0;
    },

    // Gesamtanzahl Teilnehmende
    gesamteTeilnehmendeAnzahlInVerlaengerungen() {
      const verlExtensions = this.aggregatedVerlaengerungen.reduce(
        (sum, v) => sum + (v.teilnehmerNamen?.length ?? 0),
        0
      );

      const eigenExtensions = Object.values(this.groupedVerleangerungenInEigenregie).reduce(
        (sum, verleangerung) => sum + (verleangerung.teilnehmerNamen?.length ?? 0),
        0
      );

      const otaExtensions = Object.values(
        this.groupedVerleangerungenOtaOderCountryManager(this.allVerlaengerungenOTA)
      ).reduce((sum, verleangerung) => sum + (verleangerung.teilnehmerNamen?.length ?? 0), 0);

      const countryManagerExtensions = Object.values(
        this.groupedVerleangerungenOtaOderCountryManager(this.allVerlaengerungenCountryManager)
      ).reduce((sum, verleangerung) => sum + (verleangerung.teilnehmerNamen?.length ?? 0), 0);

      return verlExtensions + eigenExtensions + otaExtensions + countryManagerExtensions;
    },

    // Tabellen-Felder
    verlaengerungenTableFields() {
      return [
        {
          key: 'reisezeitraum',
          label: 'Reisezeitraum',
          thClass: 'col-reisezeitraum',
          tdClass: 'col-reisezeitraum',
        },
        { key: 'bnr', label: 'BNR', thClass: 'col-bnr', tdClass: 'col-bnr' },
        { key: 'pax', label: 'PAX', thClass: 'col-pax', tdClass: 'col-pax' },
        { key: 'zimmertyp', label: 'Zimmertyp', thClass: 'col-zimmertyp', tdClass: 'col-zimmertyp' },
        { key: 'verpflegung', label: 'Verpflegung', thClass: 'col-verpflegung', tdClass: 'col-verpflegung' },
        {
          key: 'teilnehmernamen',
          label: 'Teilnehmernamen',
          thClass: 'col-teilnehmernamen',
          tdClass: 'col-teilnehmernamen',
        },
        {
          key: 'kundenwuensche',
          label: 'Kundenwünsche',
          thClass: 'col-kundenwuensche',
          tdClass: 'col-kundenwuensche',
        },
      ];
    },

    verlaengerungenInEigenregieTableFields() {
      return [
        {
          key: 'reisezeitraum',
          label: 'Reisezeitraum',
          thClass: 'col-reisezeitraum',
          tdClass: 'col-reisezeitraum',
        },
        { key: 'bnr', label: 'BNR', thClass: 'col-bnr', tdClass: 'col-bnr' },
        { key: 'pax', label: 'PAX', thClass: 'col-pax', tdClass: 'col-pax' },
        {
          key: 'zimmer_empty',
          label: '',
          thClass: 'col-zimmer ',
          tdClass: 'col-zimmer ',
        },
        {
          key: 'verpflegung_empty',
          label: '',
          thClass: 'col-verpflegung ',
          tdClass: 'col-verpflegung ',
        },
        {
          key: 'teilnehmernamen',
          label: 'Teilnehmernamen',
          thClass: 'col-teilnehmernamen',
          tdClass: 'col-teilnehmernamen',
        },
        {
          key: 'kundenwuensche_empty',
          label: '',
          thClass: 'col-kundenwuensche ',
          tdClass: 'col-kundenwuensche ',
        },
      ];
    },

    verlaengerungenOtaOderCountryManagerFields() {
      return [
        {
          key: 'reisezeitraum',
          label: 'Reisezeitraum',
          thClass: 'col-reisezeitraum',
          tdClass: 'col-reisezeitraum',
        },
        { key: 'bnr', label: 'BNR', thClass: 'col-bnr', tdClass: 'col-bnr' },
        { key: 'pax', label: 'PAX', thClass: 'col-pax', tdClass: 'col-pax' },
        {
          key: 'zimmerartVerpflegung',
          label: 'Zimmertyp',
          thClass: 'col-zimmer ',
          tdClass: 'col-zimmer ',
        },
        {
          key: 'verpflegung_empty',
          label: '',
          thClass: 'col-verpflegung ',
          tdClass: 'col-verpflegung ',
        },
        {
          key: 'teilnehmernamen',
          label: 'Teilnehmernamen',
          thClass: 'col-teilnehmernamen',
          tdClass: 'col-teilnehmernamen',
        },
        {
          key: 'kundenwuensche_empty',
          label: '',
          thClass: 'col-kundenwuensche ',
          tdClass: 'col-kundenwuensche ',
        },
      ];
    },

    optionalsTableFields() {
      return [
        { key: 'bnr', label: 'BNR', thStyle: { width: '16rem' } },
        { key: 'teilnehmernamen', label: 'Teilnehmernamen' },
      ];
    },

    allOptionalsMitKontingent() {
      return this.allTeilnehmerFromActiveBuchungen.flatMap(teilnehmer =>
        teilnehmer.optionalsMitKontingent
          .filter(opt => opt.deletedAt === null)
          .map(optionalsMit => ({
            ...optionalsMit,
            bnr: teilnehmer.bnr,
            teilnehmerName: teilnehmer.teilnehmerName,
            // spezieller schlüssel mit dem Datum des optionals, da es auch optionals mit dem gleichen kürzel aber unterschiedlichem Datum geben kann
            kuerzelMitDatum: optionalsMit.startdatum
              ? `${optionalsMit.kuerzel}(${new Date(optionalsMit.startdatum).toISOString().split('T')[0]})`
              : optionalsMit.kuerzel,
          }))
      );
    },

    allOptionalsOhneKontingent() {
      return this.allTeilnehmerFromActiveBuchungen.flatMap(teilnehmer =>
        teilnehmer.optionalsOhneKontingent
          .filter(opt => opt.deletedAt === null)
          .map(optionalsOhne => ({
            ...optionalsOhne,
            bnr: teilnehmer.bnr,
            teilnehmerName: teilnehmer.teilnehmerName,
          }))
      );
    },
    gruppiertMit() {
      return this.optionalsGruppierenNachBNR(this.allOptionalsMitKontingent, 'kuerzelMitDatum');
    },

    gruppiertOhne() {
      return this.optionalsGruppierenNachBNR(this.allOptionalsOhneKontingent);
    },

    tabellenFormatMit() {
      return this.erstelleTabellenFormat(this.gruppiertMit);
    },

    tabellenFormatOhne() {
      return this.erstelleTabellenFormat(this.gruppiertOhne);
    },
    aggregatedOptionalsNachKuerzel() {
      return {
        ...this.tabellenFormatMit,
        ...this.tabellenFormatOhne,
      };
    },

    // Alle Collapse-Keys des Optionals-Tabs
    optionalsKeys() {
      return Object.keys(this.aggregatedOptionalsNachKuerzel);
    },

    // Alle Collapse-Keys des Verlängerungen-Tabs inkl. der festen Sonderblöcke
    extensionsKeys() {
      const keys = Object.keys(this.aggregatedVerlaengerungenNachKuerzel);

      if (this.areVerleangerungenInEigenregieExistent) {
        keys.push('eigenregie');
      }
      if (this.areVerleangerungenOTAExistent) {
        keys.push('ota');
      }
      if (this.areVerleangerungenCountryManagerExistent) {
        keys.push('countryManager');
      }

      return keys;
    },

    // Collapse-Keys des aktiven Tabs
    currentKeys() {
      return this.activeTab === 'optionals' ? this.optionalsKeys : this.extensionsKeys;
    },

    // Sind alle Blöcke des aktiven Tabs ausgeklappt
    areAllOpen() {
      return this.currentKeys.length > 0 && this.currentKeys.every(key => this.isOpen[key]);
    },
  },
  methods: {
    formatName,
    // gruppierung Verlängerungen OTA oder CountryManager
    groupedVerleangerungenOtaOderCountryManager(allVerlaengerungen) {
      return allVerlaengerungen.reduce((acc, curr) => {
        const key = `${curr.bnr}-${curr.reisezeitraum}`;

        if (!acc[key]) {
          acc[key] = {
            bnr: curr.bnr,
            reisezeitraum: curr.reisezeitraum,
            pax: curr.pax,
            unterkunft: curr.unterkunft,
            zimmerartVerpflegung: curr.zimmerartVerpflegung,
            kreditor: curr.kreditor,
            teilnehmerNamen: [...curr.teilnehmerNamen],
          };
        } else {
          acc[key].teilnehmerNamen.push(...curr.teilnehmerNamen);
        }
        return acc;
      }, {});
    },

    // Format für Tabelle der Verlängerungen OTA oder CountryManager
    formatVerleangerungOtaOderCountryManager(groupedVerlaengerungen) {
      return Object.values(groupedVerlaengerungen).flatMap(gruppe => {
        return gruppe.teilnehmerNamen.map((teilnehmerName, index) => ({
          bnr: index === 0 ? gruppe.bnr : '',
          reisezeitraum: index === 0 ? gruppe.reisezeitraum : '',
          pax: index === 0 ? gruppe.pax : '',
          unterkunft: index === 0 ? gruppe.unterkunft : '',
          zimmerartVerpflegung: index === 0 ? gruppe.zimmerartVerpflegung : '',
          kreditor: index === 0 ? gruppe.kreditor : '',
          teilnehmerName,
        }));
      });
    },

    toggleCollapse(key) {
      this.$set(this.isOpen, key, !this.isOpen[key]);
    },

    toggleAllCollapse() {
      const neuerStatus = !this.areAllOpen;
      this.currentKeys.forEach(key => this.$set(this.isOpen, key, neuerStatus));
    },

    formatZeitraum(startdatum, dauer) {
      if (!startdatum || !dauer) return '';
      const start = new Date(startdatum);
      const end = new Date(start.getTime() + dauer * 24 * 60 * 60 * 1000);
      return `${this.formatDate(start)} - ${this.formatDate(end)}`;
    },

    formatDate(date) {
      if (!date) return '-';
      return new Date(date).toLocaleDateString('de-DE');
    },

    formatKundenwuensche(kundenwuensche) {
      if (!kundenwuensche) {
        return '-';
      }

      const wishesArray = Array.isArray(kundenwuensche) ? kundenwuensche : [kundenwuensche];

      const wuensche = wishesArray
        // das führende komma entfernen
        .map(item => item?.wunsch?.replace(/^,+\s*/, '') ?? '')
        .filter(
          wunsch =>
            wunsch &&
            wunsch !== '(vorb. Verfügbarkeit bzw. Aufpreisen)' &&
            wunsch !== 'Unverbindlicher Kundenwunsch:'
        );

      return wuensche.length
        ? wuensche.map(wunsch => wunsch.substring(0, 1).toUpperCase() + wunsch.substring(1)).join(', ')
        : '-';
    },

    nameFormatter(fullName) {
      if (fullName === null || fullName === undefined) {
        return '';
      }
      return fullName
        .split(' ')
        .map(name => name.substring(0, 1).toUpperCase() + name.substring(1).toLowerCase())
        .join(' ')
        .split('-')
        .map(name => name.substring(0, 1).toUpperCase() + name.substring(1))
        .join('-');
    },

    optionalsGruppierenNachBNR(optionals, keyField = 'kuerzel') {
      return optionals.reduce((acc, curr) => {
        // Bestimme den Schlüssel (entweder mit oder ohne Datum)
        const schluessel = keyField === 'kuerzelMitDatum' ? curr.kuerzelMitDatum : curr.kuerzel;

        // Prüfe, ob bereits ein Eintrag mit diesem Schlüssel und dieser BNR existiert
        const matchingObject = acc.find(
          optional => optional.kuerzelDisplay === schluessel && optional.bnr === curr.bnr
        );

        if (matchingObject) {
          matchingObject.teilnehmerNamen = [...matchingObject.teilnehmerNamen, curr.teilnehmerName];
        } else {
          const newObject = {
            ...curr,
            // fügt den schlüssel hinzu
            kuerzelDisplay: schluessel,
            teilnehmerNamen: [curr.teilnehmerName],
          };
          delete newObject.teilnehmerName;
          acc.push(newObject);
        }

        return acc;
      }, []);
    },

    erstelleTabellenFormat(gruppierteOptionals) {
      return gruppierteOptionals.reduce((acc, curr) => {
        // Erstelle für jeden Teilnehmer eine Zeile
        const neueZeilen = curr.teilnehmerNamen.map((name, index) => {
          if (index === 0) {
            return {
              bnr: curr.bnr,
              teilnehmerName: name,
              langname: curr.langname,
              startdatum: curr.startdatum,
            };
          } else {
            return {
              bnr: '',
              teilnehmerName: name,
              langname: curr.langname,
              startdatum: curr.startdatum,
            };
          }
        });

        if (curr.kuerzelDisplay in acc) {
          acc[curr.kuerzelDisplay] = [...acc[curr.kuerzelDisplay], ...neueZeilen];
        } else {
          acc[curr.kuerzelDisplay] = neueZeilen;
        }
        return acc;
      }, {});
    },
  },
};
</script>

<style scoped lang="scss">
@import '../../../assets/sass/components/expandable-section-styles.scss';

.expandable-row .section-header {
  box-shadow: 0px 2px 4px 0px #0000001a;
}

.expandable-row .flight-table-container {
  margin-top: 0;
  border-radius: 0;
}

.expandable-row.expandable-row-expanded .section-header {
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  border-bottom: none;
}

.flight-table-container .blank-flight-table {
  :deep(thead th),
  :deep(tbody td) {
    text-align: left;
    padding: 0 0.75rem !important;
  }

  :deep(.table) {
    table-layout: fixed;
    width: 100%;
  }
}

.col-reisezeitraum {
  width: 180px;
  min-width: 180px;
  max-width: 180px;
}

.col-bnr {
  width: 100px;
  min-width: 100px;
  max-width: 100px;
}

.col-pax {
  width: 60px;
  min-width: 60px;
  max-width: 60px;
}

.col-zimmertyp {
  width: 150px;
  min-width: 150px;
  max-width: 150px;
}

.col-verpflegung {
  width: 130px;
  min-width: 130px;
  max-width: 130px;
}

.col-teilnehmernamen {
  width: 25%;
  min-width: 150px;
}

.col-kundenwuensche {
  width: 25%;
  min-width: 150px;
}
</style>
